import type { CreateUserTasksBulkRequest } from "@/openapi/generated";

export type CreateUserTasksBulkPayloadInput = {
  title: string;
  assigneeUserIds: number[];
  description?: string | null;
  dueAt?: string | null;
};

export function buildCreateUserTasksBulkBody(
  input: CreateUserTasksBulkPayloadInput,
): CreateUserTasksBulkRequest {
  const title = input.title.trim();
  const description = input.description?.trim();
  const dueAtRaw = input.dueAt?.trim();
  const assigneeUserIds = input.assigneeUserIds.filter(
    (id) => Number.isFinite(id) && id > 0,
  );

  if (!title) {
    throw new Error("Title is required");
  }
  if (assigneeUserIds.length === 0) {
    throw new Error("At least one assignee is required");
  }

  let dueAt: Date | null = null;
  if (dueAtRaw && dueAtRaw.length > 0) {
    const parsed = new Date(dueAtRaw);
    dueAt = Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  return {
    title,
    assigneeUserIds,
    description: description && description.length > 0 ? description : null,
    dueAt,
  };
}
